import { CommonStatus, TableSessionStatus } from "constants/enum";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";

import CustomNotification from "../CustomNotification";
import { Modal } from "antd";
import { ModalType } from "../../types/ModalType";
import { TakuContext } from "../../providers/TakuProvider";
import { TakuSettei } from "../TakuSettei/index";
import { TakuSetteiStaff } from "../TakuSetteiStaff";
import { getDetailTableSession } from "../../api/tableSession";
import { queryKeys } from "../../constants/constans";
import styles from "./styles.module.scss";
import useDragStaff from "../../hooks/useDragStaff";
import useIsMobile from "../../hooks/useIsMobile";
import useSetOkuriList from "../../hooks/useSetOkuriList";
import useSetOrderList from "../../hooks/useSetOrderList";
import useShowListStaff from "hooks/useShowListStaff";

export const ModalSettingTable = (props: ModalType) => {
  const {
    id,
    setShowModal,
    differTime,
    countNextBtn,
    infoTable,
    showModal,
    fromHistory,
  } = props;

  const [infoCodeTable, setInfoCodeTable] = useState<string>("A1");
  const { takuSettei } = useContext(TakuContext);
  const { staff, setStaffDrag } = useDragStaff();
  const [dragIndex, setDragIndex] = useState<number | null>(null); //スタッフリストのどの要素をドラッグされたか
  //タイムラインに入力されてるかのフラグ→TimeLineとTakuSetteiStaffに渡す
  const { isMobile } = useIsMobile();

  const { orderList, setOrderList } = useSetOrderList();
  const { okuriList, setOkuriList } = useSetOkuriList();
  const [listStaffNotPriority, setListStaffNotPriority] = useState<string[]>(
    []
  );
  const [listStaffCandidacy, setListStaffCandidacy] = useState<string[]>([]);

  const isSetListNotPriority = useRef<boolean>(false);

  useEffect(() => {
    if (!!infoTable && !isSetListNotPriority.current) {
      isSetListNotPriority.current = true;
      setListStaffNotPriority(infoTable?.listStaffNotPriority);
      setListStaffCandidacy(infoTable?.listStaffCandidacy);
    }
  }, [infoTable]);

  let index = id - 1;

  const { data: detailTable } = useQuery(
    [queryKeys.detailTable, infoTable?._id],
    () => getDetailTableSession(infoTable?._id),
    {
      enabled: !!infoTable?._id && !!infoTable,
      keepPreviousData: false,
    }
  );

  const handleSetOrderList = (index: number) => {
    const staffOrderExist = orderList?.find(
      (item: any) => item.index === index && item?.staff?.id === staff?.id
    );
    if (!!staffOrderExist) {
      CustomNotification({
        type: "error",
        description: "スタッフが既に指名されました。",
        message: "",
      });
    }
    if (staffOrderExist || !staff) {
      return;
    }
    setOrderList([...orderList, { staff: staff, index: index }]);
    setStaffDrag(null);
  };

  const handleSetOkuriList = (index: number) => {
    const staffOrderExist = okuriList.find(
      (item: any) => item.index === index && item?.staff?.id === staff?.id
    );

    if (!!staffOrderExist) {
      CustomNotification({
        type: "error",
        description: "スタッフが既に指名されました。",
        message: "",
      });
    }
    if (staffOrderExist || !staff) {
      return;
    }

    setOkuriList([...okuriList, { staff: staff, index: index }]);
    setStaffDrag(null);
  };

  const handleUpdateTableCode = (code: string) => {
    setInfoCodeTable(code);
  };

  return (
    <Modal
      open={showModal}
      footer={null}
      closable={false}
      closeIcon={null}
      destroyOnClose
      centered
      className={styles.modalSettingTable}
    >
      <TakuSettei
        {...(detailTable?.data || infoTable)}
        id={id}
        isSetup={!!detailTable?.data || !!infoTable}
        tableStarted={detailTable?.data?.status !== TableSessionStatus.NotStart}
        infoTable={detailTable?.data || infoTable}
        setShowModal={setShowModal}
        differTime={differTime}
        countNextBtn={countNextBtn}
        orderList={orderList}
        okuriList={okuriList}
        handleSetOrderList={handleSetOrderList}
        handleSetOkuriList={handleSetOkuriList}
        handleUpdateTableCode={handleUpdateTableCode}
        listStaffNotPriority={listStaffNotPriority}
        listStaffCandidacy={listStaffCandidacy}
        fromHistory={fromHistory}
      />
      {!isMobile && (
        <TakuSetteiStaff
          {...takuSettei[index]}
          takuId={infoCodeTable}
          setDragIndex={setDragIndex}
          okuriList={okuriList}
          handleSetOrderList={handleSetOrderList}
          handleSetOkuriList={handleSetOkuriList}
          listStaffNotPriority={listStaffNotPriority}
          setListStaffNotPriority={setListStaffNotPriority}
          listStaffCandidacy={listStaffCandidacy}
          setListStaffCandidacy={setListStaffCandidacy}
        />
      )}
    </Modal>
  );
};
